/*
 * @Author: 邓鹏
 * @Date: 2026-03-20 16:17:10
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-03-20 17:40:50
 * @FilePath: /marketing-landing-fe/src/const/base.ts
 * @Description:
 */
export function envPath(name) {
  if (name === void 0) {
    name = 'pro';
  }

  return name === 'pro' ? '' : ".".concat(name);
}
export function envFactory(key) {
  var _a, _b;

  return ((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b[key]) || '';
}
export var envName = envFactory('ENV_NAME'); // 环境变量

export var buildTime = envFactory('BUILD_TIME');
export var envCdnUrl = envFactory('CDN_DOMAIN');
export var MOCK = envFactory('MOCK');
export var tagName = envFactory('CI_TAG_NAME');
export var APP_NAME = envFactory('APP_NAME') || 'jojo';
export var ENV_BASE = envFactory('ENV_BASE');
export var WX_APP_ID = envFactory('WX_APP_ID');
export var isDebugEnv = envName === 'fat' || envName === 'dev' || envName === 'uat';